import { CostType } from "types/enum";

import { lazyLoadComponent } from "utilities/LazyLoad.utility";
import { routes } from "utilities/routes";

import { type IModalConfiguration } from "commonComponents/btWrappers/BTModal/BTModal";
import { BTSuspense } from "commonComponents/btWrappers/BTSuspense/BTSuspense";
import { RouteRelative } from "commonComponents/utilities/RouteRelative/RouteRelative";

const CostCodeDetails = lazyLoadComponent(() => import("./CostCodeDetails"));

interface IRouteCostCodeProps {
    modalConfig: IModalConfiguration;
}

interface ICostCodeRouteParams {
    costCodeId: string;
    costType: string;
}

export const RouteCostCode = (props: IRouteCostCodeProps) => (
    <RouteRelative
        path={routes.costCode.costCodeDetails}
        render={(routeProps) => {
            const params = routeProps.match.params as ICostCodeRouteParams;
            const costCodeId = parseInt(params.costCodeId);
            const costType = CostType[params.costType as keyof typeof CostType];

            return (
                <BTSuspense>
                    <CostCodeDetails
                        costCodeId={costCodeId}
                        costType={costType}
                        modalConfig={props.modalConfig}
                        beforeClose={() => props.modalConfig.beforeClose()}
                        {...routeProps}
                    />
                </BTSuspense>
            );
        }}
    />
);
